// ═══════════════════════════════════════════════════════════════
// Mantine notifications — apply global defaults
// Wraps notifications.show / notifications.update so every toast
// gets a close button (X) by default unless explicitly opted out.
// Imported once from main.tsx at app startup.
// ═══════════════════════════════════════════════════════════════

import { notifications } from '@mantine/notifications';

// notifications is a TypeScript-frozen object; cast to any to override
const n = notifications as any;
const origShow = n.show.bind(n);
const origUpdate = n.update.bind(n);

n.show = (notification: any) => {
  return origShow({
    withCloseButton: true,
    autoClose: 5000,
    ...notification,
  });
};

n.update = (notification: any) => {
  return origUpdate({
    withCloseButton: true,
    ...notification,
  });
};
